import { PhotoIcon } from '@heroicons/react/24/outline';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { useMediaPreview } from './useMediaPreview';
import AstroImage from '@/components/ui/custom/AstroImage';

type AnswerMediaPreviewProps = {
  mediaFile?: File | string | null;
  altText?: string;
  placeholder?: string;
};

export default function AnswerMediaPreview({
  mediaFile,
  altText,
  placeholder,
}: AnswerMediaPreviewProps) {
  const mediaPreview = useMediaPreview(mediaFile);

  return (
    <ConditionalRenderer
      condition={!!mediaPreview}
      fallback={
        <div className="flex items-center gap-2 text-base-content">
          <PhotoIcon className="size-6" />
          <span className="text-sm">{placeholder}</span>
        </div>
      }
    >
      <div className="flex flex-col gap-2 flex-1 items-start">
        <AstroImage
          src={mediaPreview ?? undefined}
          alt={altText ?? ''}
          zoomable
          className="h-23 w-23 rounded object-cover"
        />
        <ConditionalRenderer condition={!!altText}>
          <span className="text-sm text-base-content">{altText}</span>
        </ConditionalRenderer>
      </div>
    </ConditionalRenderer>
  );
}
